// Card proportions from the mocks: 168×190 (portrait). The grid is a fixed
// four columns; height rides the aspect ratio so cards stay taller-than-wide.
// Shared so callers' mini preview cards keep the same proportions as the
// picker's cards.
export const ASSET_CARD_ASPECT_RATIO = "168 / 190";
